var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9989 16C31.9989 9.37234 26.6263 4 19.9997 4C13.371 4 7.99902 9.37218 7.99902 16C7.99902 22.6268 13.3712 28 19.9997 28C26.6265 28 31.9989 22.6268 31.9989 16Z",
    fill: "#3D83D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.063 13.0703H14.2852V21.0091H17.063V13.0703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6742 9.10156C14.804 9.10156 14.1229 9.90117 14.3191 10.8019C14.4331 11.3251 14.8598 11.7457 15.3849 11.8511C16.2803 12.031 17.063 11.3532 17.063 10.4906C17.063 9.7247 16.4424 9.10156 15.6742 9.10156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1928 15.5091C26.006 14.0128 25.2575 13.0703 23.2348 13.0703C21.7992 13.0703 21.2284 13.2942 20.8992 13.9209V13.0703H18.6504V21.0091H20.9647V16.8535C20.9647 15.8161 21.1612 15.0325 22.4439 15.0325C23.7082 15.0325 23.8098 15.9969 23.8098 16.9208V21.0093H26.193C26.1928 21.0093 26.2369 15.8588 26.1928 15.5091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -0.000976562,
    y: 0,
    width: 39.9998,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.160784 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.8cac51730c080589293595bd3e59b2bd.svg";
export { ForwardRef as ReactComponent };